import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterModule, RouterOutlet } from '@angular/router';
import { ProfileSettingsComponent } from './profile-settings/profile-settings.component';
import { BillingSettingsComponent } from './billing-settings/billing-settings.component';
import { MainSettingsComponent } from './main-settings/main-settings.component';
import { UiKitModule } from '../shared/ui-kit/ui-kit.module';
import { AboutComponent } from './about/about.component';
import { LetDirective, PushPipe } from '@ngrx/component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { SharedModule } from '../shared/shared.module';
import { DirectivesModule } from '../shared/directives/directives.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLabel } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import {UiUserSettingsDateComponent} from "../shared/ui-kit/ui-user-settings-date/ui-user-settings-date.component";
import { UiPreloaderComponent } from '../shared/ui-kit/ui-preloader/ui-preloader.component';
import { OrganizationSettingsComponent } from './organization-settings/organization-settings.component';
import { UiButtonComponent, UiPrefixInputComponent, UiAvatarComponent, UiCopyClipboardComponent, UiToggleComponent } from '@ui';

@NgModule({
  declarations: [
    ProfileSettingsComponent,
    BillingSettingsComponent,
    MainSettingsComponent,
    AboutComponent,
  ],
  imports: [
    CommonModule,
    ImageCropperComponent,
    RouterModule.forChild([
      {
        path: '',
        component: MainSettingsComponent,
        children: [
          {
            path: 'profile',
            component: ProfileSettingsComponent,
          },
          {
            path: 'organization',
            component: OrganizationSettingsComponent,
          },
          {
            path: '',
            redirectTo: 'organization',
            pathMatch: 'full',
          },
        ],
      },
    ]),
    UiKitModule,
    UiPrefixInputComponent,
    UiButtonComponent,
    LetDirective,
    PushPipe,
    MatProgressBarModule,
    SharedModule,
    DirectivesModule,
    NgScrollbarModule,
    MatLabel,
    MatSelect,
    MatOption,
    UiCopyClipboardComponent,
    UiToggleComponent,
    UiUserSettingsDateComponent,
    UiPreloaderComponent,
    RouterLink,
    RouterOutlet,
    RouterLinkActive,
    UiAvatarComponent,
  ],
  exports: [],
})
export class AppSettingsModule {}
